import Button from "components/button";
import Loading from "components/center-loading";
import GenericModal from "components/generic-modal";
import CloseIcon from "components/icons/icn-close.icon";
import intl from "react-intl-universal";
import { useProductionPlanSupplierContext } from "../../../context";
import {
  CloseButton,
  ModalActions,
  ModalContent,
  ModalHeader,
  ModalMessage,
  ModalTitle,
} from "./styled";

type Props = Readonly<{
  open: boolean;
  count: number;
  error?: string | null;
  onClose: () => void;
  onConfirm: () => void;
}>;


const DeleteConfirmationModal = ({ open, count, onClose, onConfirm }: Props) => {
  const { loading: isLoading } = useProductionPlanSupplierContext();
  const message = intl.get(
    count === 1
      ? "productionPlanSupplier.deleteModal.messageSingular"
      : "productionPlanSupplier.deleteModal.messagePlural",
    { count }
  );

  return (
    <GenericModal
      open={open}
      onRequestClose={isLoading ? () => undefined : onClose}
      modalStyle={{ width: "auto" }}
    >
      <ModalContent>
        <Loading isLoading={isLoading} fullHeightParent />
        <ModalHeader>
          <ModalTitle id="delete-modal-title">
            {intl.get("productionPlanSupplier.deleteModal.title")}
          </ModalTitle>
          <CloseButton
            type="button"
            aria-label={intl.get("productionPlanSupplier.deleteModal.close")}
            onClick={onClose}
            disabled={isLoading}
          >
            <CloseIcon width={16} height={16} aria-hidden="true" />
          </CloseButton>
        </ModalHeader>
        <ModalMessage aria-live="polite">{message}</ModalMessage>
        <ModalActions>
          <Button
            type="button"
            buttonType="default"
            value={intl.get("productionPlanSupplier.deleteModal.cancel")}
            onClick={onClose}
            disabled={isLoading}
          />
          <Button
            type="button"
            buttonType="danger"
            value={intl.get("productionPlanSupplier.deleteModal.proceed")}
            onClick={onConfirm}
            disabled={isLoading}
            aria-busy={isLoading}
          />
        </ModalActions>
      </ModalContent>
    </GenericModal>
  );
};

export default DeleteConfirmationModal;
